import { Link, useParams } from 'react-router-dom';
import { DOCPACK_CATALOG, pricingFor } from '@core/docpack-fe-helpers';

export function DocPackDetailRoute() {
  const { sku } = useParams<{ sku: string }>();
  const item = DOCPACK_CATALOG.find((d) => d.sku === sku);

  if (!item) {
    return (
      <main style={{ maxWidth: 560, margin: '96px auto', padding: '0 16px', textAlign: 'center' }}>
        <h1>Doc Pack không tồn tại</h1>
        <p style={{ color: 'var(--color-muted)' }}>SKU "<code>{sku}</code>" không có trong catalog.</p>
        <Link className="cta-primary" to="/docpack">
          {'<- '}Tất cả Doc Pack
        </Link>
      </main>
    );
  }

  const usd = pricingFor(item, 'USD');
  const vnd = pricingFor(item, 'VND');

  return (
    <main style={{ maxWidth: 720, margin: '48px auto', padding: '0 16px' }}>
      <p style={{ marginBottom: 8 }}>
        <Link to="/docpack" style={{ color: 'var(--color-muted)', fontSize: 14 }}>
          {'<- '}Tất cả Doc Pack
        </Link>
      </p>
      <h1 style={{ marginTop: 0 }}>{item.title_vn}</h1>
      <p style={{ color: 'var(--color-muted)', fontSize: 16, lineHeight: 1.6 }}>
        {item.description_vn}
      </p>
      <ul style={{ fontSize: 14, color: 'var(--color-muted)', marginBottom: 24 }}>
        <li>{item.est_pages} trang PDF</li>
        <li>{item.section_count} mục</li>
        <li>Trích dẫn Điều/Khoản đầy đủ từ kho VBPL</li>
      </ul>

      <div
        style={{
          padding: 20,
          border: '1px solid var(--color-border, rgba(0,0,0,0.12))',
          borderRadius: 12,
          background: 'var(--color-card, #faf9f7)',
        }}
      >
        <p style={{ margin: 0, fontSize: 13, color: 'var(--color-muted)' }}>Giá Day-1</p>
        <div style={{ fontSize: 24, fontWeight: 600, marginTop: 4 }}>
          {vnd.display} <span style={{ fontSize: 14, color: 'var(--color-muted)', fontWeight: 400 }}>- {usd.display}</span>
        </div>
        <p style={{ margin: '12px 0 16px', fontSize: 13 }}>
          Doc Pack đang trong giai đoạn pre-order Beta. Đăng ký nhận thông báo khi Day-1 ra mắt.
        </p>
        <Link className="cta-primary" to={`/auth/signup?redirect=/docpack/${item.sku}`}>
          Đăng ký nhận thông báo
          <span className="arrow" aria-hidden>{'->'}</span>
        </Link>
      </div>
    </main>
  );
}
